import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

export default makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    padding: theme.spacing(6),
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  titleText: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2)
  },
  icon: {
    flexShrink: 0,
    width: 32,
    height: 32
  },
  policyName: {
    flex: 1,
    margin: 0,
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '24px',
    color: theme.onCard.white
  },
  term: {
    whiteSpace: 'nowrap',
    lineHeight: '16px',
    color: theme.colorPalette.beige_60,
    ...reskinStyles(theme, { color: theme.colors.text_secondary })
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  }
}));
